import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import PreviousButtonInlineSvg from '../../../assets/svg-icons/PreviousButton.inline.svg';
import {BarButton} from '../BarButton/BarButton';
import styles from './PreviousButton.scss';

export function PreviousButton(props) {
  const {onClick, className: outerClassName} = props;
  const {t} = useTranslation();
  const className = classNames(styles.previousButton, outerClassName);
  return (
    <BarButton
      onClick={onClick}
      accName={t('mgw.aria.controlBar.previousButtonAccName')}
      SvgIcon={PreviousButtonInlineSvg}
      dataHook="previous-button"
      className={className}
    />
  );
}

PreviousButton.propTypes = {
  t: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
